export enum Environment {
  DEV = 'dev',
  QA = 'qa',
  PROD = 'prod',
};
